import React from "react";

interface TagProps {
  text: string;
  backgroundColor?: string;
  textColor?: string;
  size?: "small" | "medium" | "large";
  className?: string;
  onClick?: () => void;
}

const Tag: React.FC<TagProps> = ({
  text,
  backgroundColor = "#219ebc",
  textColor = "white",
  size = "small",
  className = "",
  onClick,
}) => {
  const isDefaultColors =
    backgroundColor === "#219ebc" && textColor === "white";

  const tagClasses = [
    "tag",
    size,
    onClick ? "clickable" : "",
    isDefaultColors ? "default-colors" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const customStyles = !isDefaultColors
    ? {
        backgroundColor,
        color: textColor,
      }
    : {};

  return (
    <div className={`${tagClasses}`} onClick={onClick} style={customStyles}>
      {text}
    </div>
  );
};

export default Tag;
